module.exports = __webpack_public_path__ + "static/media/sample-map.96ae7d70.webp";